export interface IRanking {
  monthlyData: RankingByScope;
  generalData: RankingByScope;
}

export interface RankingByScope {
  center: Ranking;
  platform: Ranking;
}

export type Ranking = {
  clientCode: string;
  center: string;
  totalUsers: number;
  slots: SlotData[];
};

export interface SlotData {
  user: string;
  userName: string;
  position: number;
  score: number;

  color: string;
  content: string;
  pictureUrl: string;
}

export enum RankingType {
  MONTHLY = 'MONTHLY',
  GENERAL = 'GENERAL',
}
